// Left-right mirroring for quiz photographs.
//
// A region pack holds a handful of photos per bird, and a learner who has met
// the same Steller's Jay facing left twenty times can start answering the
// picture rather than the bird — the pose, the branch, the patch of sky. A bird
// is the same bird facing the other way, so flipping some of the prompts
// breaks the memorised composition without teaching anything false.
//
// Only ever horizontal. Upside-down is not a way anyone sees a bird, and a
// vertical flip would be a new puzzle rather than a new view of an old one.

/** How often a quiz photograph is shown mirrored. */
export const MIRROR_CHANCE = 0.3;

/** One draw: whether the next photo goes up flipped. */
export function drawMirror(rnd: () => number = Math.random): boolean {
  return rnd() < MIRROR_CHANCE;
}
